/**
 * Seed election: among all clients whose awareness says they're viewing
 * `field`, the lowest clientID seeds the empty fragment. Everyone else waits
 * for the `collabMeta` seeded flag (the caller retries on a short timer, so a
 * departed elected peer just yields to the next-lowest on the next attempt).
 */
export function electSeeder(
    states: Map<number, Record<string, any>>,
    localClientId: number,
    field: string
): boolean {
    let lowest = localClientId;
    states.forEach((state, clientId) => {
        if (state?.sectionField === field && clientId < lowest) {
            lowest = clientId;
        }
    });
    return lowest === localClientId;
}
